import { useQuery } from "@tanstack/react-query";
import { manageKeywordApi } from "../../../../entities/keyword";
import { manageProductApi } from "../../../../entities/product";
import { manageArticleApi } from "../../../../entities/article";
import { keywordQueryKeys } from "../../../../entities/keyword";
import { productQueryKeys } from "../../../../entities/product";
import { articleQueryKeys } from "../../../../entities/article";

export const useFilterDataQuery = () => {
  const keywordsQuery = useQuery({
    queryKey: keywordQueryKeys.list(),
    queryFn: manageKeywordApi.getKeywordsWithCategory,
    staleTime: 10 * 60 * 1000, // 10분
    gcTime: 30 * 60 * 1000, // 30분
  });

  const productsQuery = useQuery({
    queryKey: productQueryKeys.list(),
    queryFn: manageProductApi.getProductList,
    staleTime: 10 * 60 * 1000, // 10분
    gcTime: 30 * 60 * 1000, // 30분
  });

  const uxEvaluationsQuery = useQuery({
    queryKey: articleQueryKeys.uxEvaluationCount(),
    queryFn: manageArticleApi.getUxEvaluationCount,
    staleTime: 5 * 60 * 1000, // 5분
    gcTime: 15 * 60 * 1000, // 15분
  });

  return {
    keywordsQuery,
    productsQuery,
    uxEvaluationsQuery,
    isLoading:
      keywordsQuery.isLoading ||
      productsQuery.isLoading ||
      uxEvaluationsQuery.isLoading,
    isError:
      keywordsQuery.isError ||
      productsQuery.isError ||
      uxEvaluationsQuery.isError,
  };
};
